import React, { useEffect, useMemo, useRef, useState } from "react"
import PropTypes from "prop-types"
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css"
import EcommerceOrdersModal from "./EcommerceOrdersModal"
import {
  Button,
  Col,
  Row,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  InputGroup,
  UncontrolledTooltip,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import classnames from "classnames"
import RejectModal from "./RejectModal"
import TableContainerV1 from "components/Common/TableContainerV1"
import { getOrderList, getOrderStatusCount, updateOrder } from "http/order/order"
import { startCase } from "lodash"
import { useNavigate, useLocation } from "react-router-dom"
import ToastDialog from "components/Common/ToastDialog"
import { formatDateTime, formatNumberWithCommas, isPermission } from "common/utility"
import Flatpickr from "react-flatpickr";
import { Tooltip } from 'react-tooltip';
import moment from "moment"
import momentTz from 'moment-timezone';
import FullPageLoader from "components/Common/FullPageLoader"

function DealerOrderRequest() {
  document.title = "Orders Request | DMS"
  const navigate = useNavigate()
  const [customActiveTab, setcustomActiveTab] = useState("1")
  const [modal1, setModal1] = useState(false)
  const [cancelModal, setCancelModal] = useState(false);
  const [cancelOrderId, setCancelOrderId] = useState(null)
  const [pageSize, setPageSize] = useState(10)
  const [searchValue, setSearchValue] = useState("")
  const [columnId, setColumnId] = useState("id")
  const [sortingOrderStatus, setSortingOrderStatus] = useState("desc")
  const [sortingOptions, setSortingOptions] = useState({
    column: "id",
    isAsc: false,
    optionalColumn: ["Action", "view"],
  })
  const [allOrderList, setAllOrderList] = useState([])
  const [pendingOrderList, setPendingOrderList] = useState([])
  const [processingOrderList, setProcessingOrderList] = useState([])
  const [processedOrderList, setProcessedOrderList] = useState([])
  const [rejectOrderList, setRejectOrderList] = useState([])
  const [cancelledOrderList, setCancelledOrderList] = useState([])
  const [activeOrder, setActiveOrder] = useState("all")
  const [acceptOrderId, setAcceptOrderId] = useState(null)
  const [rejectOrderId, setRejectOrderId] = useState(null)
  const [toastInfo, setToastInfo] = useState({ showToast: false })
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const tab = queryParams.get("tab")
  const { id: userId } = JSON.parse(localStorage.getItem('user'));
  const [uploadPermission, setUploadPermission] = useState(false);
  const [isUpdateOrder, setIsUpdateOrder] = useState(false)
  
  const [filters, setFilters] = useState({
    startDate: '',
    endDate: '',
  })
  const flatpickrRef = useRef(null);


  const [countStatus, setCountStatus] = useState({});
  const toggleCustom = tab => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab)
    }
  }
  const [allpagination, setAllPagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  })
  const [pendingpagination, setPendingPagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  })
  const [processingPagination, setProcessingPagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  })
  const [processedPagination, setProcessedPagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  })
  const [rejectedPagination, setRejectedPagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  })
  const [cancelledPagination, setCancelledPagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  })

  const toggleViewModal = () => setModal1(!modal1)

  const user = JSON.parse(localStorage.getItem("user"))

  const handleCancelOrder = remarks => {
    setCancelModal(false)
    updateOrderStatus("cancelled", remarks)

  }

  const onClickCancel = id => {
    setCancelModal(true)
    setCancelOrderId(id)
  }

  const getOrderId = (orderstatus, acceptOrderId, cancelOrderId, rejectOrderId) => {
    if (orderstatus === "accepted") {
      return acceptOrderId;
    } else if (orderstatus === "cancelled") {
      return cancelOrderId;
    } else {
      return rejectOrderId;
    }
  };

  const updateOrderStatus = async (orderstatus, remarks = "") => {
    try {
      setIsUpdateOrder(true)
      let res = await updateOrder({
        id: getOrderId(orderstatus, acceptOrderId, cancelOrderId, rejectOrderId),
        orderStatus: orderstatus,
        remarks: remarks,
      })
      const { status, message } = res
      if (status) {
        setIsUpdateOrder(false)
        setToastInfo({
          message: message,
          showToast: true,
          role: "success",
        })
      }
      setAcceptOrderId(null)
      setRejectOrderId(null)
      fetchStatusCount()
      fetchOrderListByStatus("all", setAllOrderList)
      fetchOrderListByStatus("pending", setPendingOrderList)
      fetchOrderListByStatus("processing", setProcessingOrderList)
      fetchOrderListByStatus("processed", setProcessedOrderList)
      fetchOrderListByStatus("rejected", setRejectOrderList)
      fetchOrderListByStatus("cancelled", setCancelledOrderList)

    } catch (err) {
      setToastInfo({
        message: err.message,
        showToast: true,
        role: "error",
      })
      setIsUpdateOrder(false)
      setAcceptOrderId(null)
      setRejectOrderId(null)
    }
  }

  const getStatusComponent = (val) => {
    const statusMap = {
      processed: <p className="bg-green rounded-pill status-pill text-white  d-flex justify-content-center py-1 px-0">Processed</p>,
      processing: <p className="bg-warning rounded-pill status-pill text-white  d-flex justify-content-center py-1 px-0" >Processing</p>,
      rejected: <p className="bg-danger rounded-pill status-pill text-white  d-flex justify-content-center py-1 px-0">Rejected</p>,
      pending: <p className="bg-warning rounded-pill status-pill text-white  d-flex justify-content-center py-1 px-0" >Pending</p>,
      cancelled: <p className="bg-danger rounded-pill status-pill text-white  d-flex justify-content-center py-1 px-3" >Cancelled</p>,
    };

    return statusMap[val] || null;
  };

  const checkPermissions = async () => {
    const isUploadPermission = await isPermission("bulk_upload_orders", "upload_permission")
    setUploadPermission(isUploadPermission)
  }


  const getViewDetailsComponent = (cellProps, navigate, onClickCancel) => {

    const handleViewClick = () => {
      navigate(`/customer/request-order/${cellProps.row.original.id}`)
    };

    const handleCancelClick = () => {
      onClickCancel(cellProps.row.original.id)
    };

    return (
      <>
        <UncontrolledDropdown>
          <DropdownToggle tag="a" className="card-drop">
            <i className="mdi mdi-dots-horizontal font-size-18"></i>
          </DropdownToggle>

          <DropdownMenu className="dropdown-menu-end">
            <DropdownItem
              onClick={handleViewClick}
            >
              <i
                className="mdi mdi-eye font-size-16 text-success me-1"
                id="edittooltip"
              ></i>
              View
            </DropdownItem>
            {(cellProps.row.original.orderStatus === "pending") && (
              <DropdownItem
                onClick={handleCancelClick}
              >
                <i
                  className="mdi mdi-close font-size-16 text-danger me-1"
                  id="edittooltip"
                ></i>
                Cancel
              </DropdownItem>
            )}
          </DropdownMenu>
        </UncontrolledDropdown>
      </>

    );
  };



  const columns = useMemo(
    () => [
      {
        Header: "Order Request ID",
        accessor: "orderCode",
        width: "150px",
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: cellProps => {
          return cellProps.value ? cellProps.value : '';
        },
      },
      {
        Header: "Date",
        accessor: "orderDate",
        filterable: true,
        Cell: cellProps => {
          const value = cellProps.value ? cellProps.value : '';
          return formatDateTime(value)
        },
      },
      {
        Header: "Total Amount",
        accessor: "totalAmount",
        filterable: true,
        alignRight: true,
        Cell: cellProps => {
          const value = cellProps.value ? cellProps.value : 0;
          return (
            <div style={{ textAlign: 'right' }}>
              {formatNumberWithCommas(value)}
            </div>
          );
        }
      },
      {
        Header: "Status",
        accessor: "orderStatus",
        filterable: true,
        Cell: (cellProps) => getStatusComponent(cellProps.value),
      },
      {
        Header: "Action",
        accessor: "view",
        disableFilters: true,
        Cell: (cellProps) => getViewDetailsComponent(cellProps, navigate, onClickCancel)
      },
    ],
    []
  )

  const pendinColumns = useMemo(
    () => [
      {
        Header: "Order Request ID",
        accessor: "orderCode",
        width: "150px",
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: cellProps => {
          return cellProps.value ? cellProps.value : '';
        },
      },
      {
        Header: "Date",
        accessor: "orderDate",
        filterable: true,
        Cell: cellProps => {
          const value = cellProps.value ? cellProps.value : '';
          return formatDateTime(value)
        },
      },
      {
        Header: "Total Amount",
        accessor: "totalAmount",
        filterable: true,
        alignRight: true,
        Cell: cellProps => {
          const value = cellProps.value ? cellProps.value : 0;
          return (
            <div style={{ textAlign: 'right' }}>
              {formatNumberWithCommas(value)}
            </div>
          );
        }
      },
      {
        Header: "Status",
        accessor: "orderStatus",
        filterable: true,
        Cell: (cellProps) => getStatusComponent(cellProps.value),
      },
      {
        Header: "Action",
        accessor: "view",
        disableFilters: true,
        Cell: (cellProps) => getViewDetailsComponent(cellProps, navigate, onClickCancel)
      },
    ],
    []
  )

  const rejectColumns = useMemo(
    () => [
      {
        Header: "Order Request ID",
        accessor: "orderCode",
        width: "150px",
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: cellProps => {
          return cellProps.value ? cellProps.value : '';
        },
      },
      {
        Header: "Date",
        accessor: "orderDate",
        filterable: true,
        Cell: cellProps => {
          const value = cellProps.value ? cellProps.value : '';
          return formatDateTime(value)
        },
      },
      {
        Header: "Total Amount",
        accessor: "totalAmount",
        filterable: true,
        alignRight: true,
        Cell: cellProps => {
          const value = cellProps.value ? cellProps.value : 0;
          return (
            <div style={{ textAlign: 'right' }}>
              {formatNumberWithCommas(value)}
            </div>
          );
        }
      },
      {
        Header: "Status",
        accessor: "orderStatus",
        filterable: true,
        Cell: (cellProps) => getStatusComponent(cellProps.value),
      },
      {
        Header: "Remarks",
        accessor: "remarks",
        filterable: true,
        Cell: cellProps => {
          const maxLength = 50
          const text = cellProps.value || "-"

          const truncatedText = text.length > maxLength
            ? `${text.substring(0, maxLength)}...`
            : text

          return (
            <div>
              <span data-tooltip-id={`my-tooltip-${cellProps?.row.original?.id}`}>{truncatedText}</span>
              <Tooltip
                style={{ maxWidth: '500px', marginLeft: '1rem' }}
                id={`my-tooltip-${cellProps?.row.original?.id}`}
                place="top"
                content={text}
              />
            </div>
          );
        },
      },

      {
        Header: "Action",
        accessor: "view",
        disableFilters: true,
        Cell: (cellProps) => getViewDetailsComponent(cellProps, navigate, onClickCancel)
      },
    ],
    []
  )

  const handlePageChange = (
    page,
    pageSize,
    searchKey = searchValue,
    columnName = columnId,
    sortingOrder = sortingOrderStatus,
    filterType = filters
  ) => {
    setPageSize(pageSize)

    getOrderList({
      page,
      limit: pageSize,
      searchKey,
      columnName,
      sortingOrder,
      orderStatus: activeOrder,
      filterType,
      userId
    }).then(({ data: responseData, status }) => {
      if (status) {
        const {
          currentPage,
          totalPages,
          totalItems,
          data: orderList,
        } = responseData

        const paginationStates = {
          all: setAllPagination,
          pending: setPendingPagination,
          processing: setProcessingPagination,
          processed: setProcessedPagination,
          rejected: setRejectedPagination,
          cancelled: setCancelledPagination,
        };

        const paginationSetter = paginationStates[activeOrder];

        if (paginationSetter) {
          paginationSetter({
            pageIndex: currentPage,
            pageCount: totalPages,
            totalRecords: totalItems,
          });
        }
        const orderListSetter = {
          all: setAllOrderList,
          pending: setPendingOrderList,
          processing: setProcessingOrderList,
          processed: setProcessedOrderList,
          rejected: setRejectOrderList,
          cancelled: setCancelledOrderList
        }[activeOrder]

        orderListSetter(orderList)
      } else {
        const orderListSetter = {
          all: setAllOrderList,
          pending: setPendingOrderList,
          processing: setProcessingOrderList,
          processed: setProcessedOrderList,
          rejected: setRejectOrderList,
          cancelled: setCancelledOrderList
        }[activeOrder]
        orderListSetter([])
        const paginationStates = {
          all: setAllPagination,
          pending: setPendingPagination,
          processing: setProcessingPagination,
          processed: setProcessedPagination,
          rejected: setRejectedPagination,
          cancelled: setCancelledPagination,
        };
        const paginationSetter = paginationStates[activeOrder];
        if (paginationSetter) {
          paginationSetter({
            pageIndex: 0,
            pageCount: 0,
            totalRecords: 0,
          });
        }

      }
    }).catch(error => {
      console.error(error)
    });
  }
  const handleSortColumn = option => {
    setSortingOptions(option)
    const columnName = option.column
    setColumnId(columnName)
    const sortingOrder = option.isAsc ? "asc" : "desc"
    setSortingOrderStatus(sortingOrder)
    handlePageChange(1, pageSize, searchValue, columnName, sortingOrder)
  }

  const handleSearchFilter = (value, pageSize) => {
    const newValue = value !== undefined ? value : "";
    setSearchValue(newValue);
    handlePageChange(1, pageSize, newValue);
  }
  const handleClearSearch = () => {
    setSearchValue("")
    setFilters({ startDate: '', endDate: '' })
    flatpickrRef.current.flatpickr.clear()
    handlePageChange(1, pageSize, "", columnId, sortingOrderStatus, { startDate: '', endDate: '' })
  }

  const fetchOrderListByStatus = async (orderStatus, setOrderList) => {
    try {
      const {
        data: responseData,
        status,
      } = await getOrderList({ orderStatus, userId })

      if (status) {
        const {
          currentPage,
          totalPages,
          totalItems,
          data: orderData,
        } = responseData

        const paginationStates = {
          all: setAllPagination,
          pending: setPendingPagination,
          processing: setProcessingPagination,
          processed: setProcessedPagination,
          rejected: setRejectedPagination,
          cancelled: setCancelledPagination,
        };
        const paginationSetter = paginationStates[orderStatus];

        if (paginationSetter) {
          paginationSetter({
            pageIndex: currentPage,
            pageCount: totalPages,
            totalRecords: totalItems,
          });
        }

        setOrderList(orderData)
      } else {

        setOrderList([])
      }
    } catch (error) {
      console.error(`Error fetching ${orderStatus} order list:`, error.message)
    }
  }

  useEffect(() => {
    fetchStatusCount()
    fetchOrderListByStatus("all", setAllOrderList)
    fetchOrderListByStatus("pending", setPendingOrderList)
    fetchOrderListByStatus("processing", setProcessingOrderList)
    fetchOrderListByStatus("processed", setProcessedOrderList)
    fetchOrderListByStatus("rejected", setRejectOrderList)
    fetchOrderListByStatus("cancelled", setCancelledOrderList)
    checkPermissions()

  }, [])

  useEffect(() => {
    if (tab) {
      toggleCustom(tab)
      setFilters({
        startDate: '',
        endDate: '',
      })
      flatpickrRef.current.flatpickr.clear()
    }
  }, [ tab])

  const handleDateFilter = () => {
    handlePageChange(1, pageSize, searchValue, columnId, sortingOrderStatus, {
      ...filters,
      // startDate: momentTz(filters.startDate).tz('Asia/Kolkata').format(),
      // endDate: momentTz(filters.endDate).tz('Asia/Kolkata').format(),
    })
  }
 
  const handleDateChange = (selectedDates) => {
    if (selectedDates.length === 2) {
      setFilters({
        ...filters,
        startDate: selectedDates[0],
        endDate: selectedDates[1],
      })
    }
  };



  const customeFilterSection = (
    <div className="d-flex align-items-center justify-content-start">
      <InputGroup style={{ minWidth: '250px' }}>
        <Flatpickr
          ref={flatpickrRef}
          className="form-control"
          placeholder="Start Date - End Date"
          options={{
            mode: 'range',
            dateFormat: 'd-m-Y'
          }}
          value={[filters?.startDate, filters?.endDate]}
          onChange={handleDateChange}
        />
        <Button variant="primary"
          onClick={handleDateFilter}
          style={{ backgroundColor: "#344fa0", border: "none" }}>
          Go
        </Button>
      </InputGroup>
    </div>
  )


  const fetchStatusCount = async () => {
    try {
      let res = await getOrderStatusCount({ dealer: true })
      if (res.status) {
        setCountStatus(res.data)
      }
    } catch (err) {
      console.error(err)
    }
  }


  return (
    <React.Fragment>
      <EcommerceOrdersModal isOpen={modal1} toggle={toggleViewModal} />
      { isUpdateOrder && <FullPageLoader />}
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="mb-sm-0 text-uppercase fw-semibold fs-5">Order Request</h4>
            {
              uploadPermission && (<Button
                onClick={() => navigate(`/customer/uploadbulkorder`)}
                outline
                color="success"
              >
                <i className="bx bx-folder me-2"></i>Upload Orders
              </Button>)
            }
          </div>

          <Col lg={12}>
            <Card>
              <CardBody>
                <Nav tabs className="nav-tabs-custom nav-justified mb-3 ">
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: customActiveTab === "1",
                      })}
                      onClick={() => {
                        toggleCustom("1")
                        setActiveOrder("all")
                      }}
                    >
                      <span className="d-block d-sm-none">
                        <i className="fas fa-home"></i>
                      </span>
                      <span className="d-none d-sm-block">
                        All({countStatus.all})
                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: customActiveTab === "2",
                      })}
                      onClick={() => {
                        toggleCustom("2")
                        setActiveOrder("pending")
                      }}
                    >
                      <span className="d-block d-sm-none">
                        <i className="far fa-user"></i>
                      </span>
                      <span className="d-none d-sm-block">
                        Pending({countStatus.pending || 0})
                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: customActiveTab === "3",
                      })}
                      onClick={() => {
                        toggleCustom("3")
                        setActiveOrder("processing")
                      }}
                    >
                      <span className="d-block d-sm-none">
                        <i className="far fa-user"></i>
                      </span>
                      <span className="d-none d-sm-block">
                        Processing({countStatus.processing || 0})
                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: customActiveTab === "4",
                      })}
                      onClick={() => {
                        toggleCustom("4")
                        setActiveOrder("processed")
                      }}
                    >
                      <span className="d-block d-sm-none">
                        <i className="far fa-user"></i>
                      </span>
                      <span className="d-none d-sm-block">
                        Processed({countStatus.processed || 0})
                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: customActiveTab === "5",
                      })}
                      onClick={() => {
                        toggleCustom("5")
                        setActiveOrder("rejected")
                      }}
                    >
                      <span className="d-block d-sm-none">
                        <i className="far fa-user"></i>
                      </span>
                      <span className="d-none d-sm-block">
                        Rejected({countStatus.rejected || 0})
                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: customActiveTab === "6",
                      })}
                      onClick={() => {
                        toggleCustom("6")
                        setActiveOrder("cancelled")
                      }}
                    >
                      <span className="d-block d-sm-none">
                        <i className="far fa-user"></i>
                      </span>
                      <span className="d-none d-sm-block">
                        Cancelled({countStatus.cancelled || 0})
                      </span>
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent
                  activeTab={customActiveTab}
                  className="p-1 text-muted"
                >
                  <TabPane tabId="1">
                    <Row>
                      <Col xs="12">
                        <TableContainerV1
                          columns={columns}
                          data={allOrderList}
                          searchHelperText="Search by Request Order ID"
                          customFilterSection={customeFilterSection}
                          pagination={allpagination}
                          handlePageChange={handlePageChange}
                          handleSearchFilter={handleSearchFilter}
                          sortOptions={sortingOptions}
                          handleSortColumn={handleSortColumn}
                          handleClearSearch={handleClearSearch}
                          className="custom-header-css"
                          isTab={customActiveTab === "1" ? true : false}
                        />
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="2">
                    <Row>
                      <Col xs="12">
                        <TableContainerV1
                          columns={pendinColumns}
                          searchHelperText="Search by Request Order ID"
                          data={pendingOrderList}
                          pagination={pendingpagination}
                          handlePageChange={handlePageChange}
                          handleSearchFilter={handleSearchFilter}
                          customFilterSection={customeFilterSection}
                          sortOptions={sortingOptions}
                          handleSortColumn={handleSortColumn}
                          handleClearSearch={handleClearSearch}
                          className="custom-header-css"
                          isTab={customActiveTab === "2" ? true : false}
                        />
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="3">
                    <Row>
                      <Col xs="12">
                        <TableContainerV1
                          columns={columns}
                          searchHelperText="Search by Request Order ID"
                          data={processingOrderList}
                          pagination={processingPagination}
                          handlePageChange={handlePageChange}
                          handleSearchFilter={handleSearchFilter}
                          customFilterSection={customeFilterSection}
                          sortOptions={sortingOptions}
                          handleSortColumn={handleSortColumn}
                          handleClearSearch={handleClearSearch}
                          className="custom-header-css"
                          isTab={customActiveTab === "3" ? true : false}
                        />
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="4">
                    <Row>
                      <Col xs="12">
                        <TableContainerV1
                          columns={columns}
                          data={processedOrderList}
                          searchHelperText="Search by Request Order ID"
                          pagination={processedPagination}
                          handlePageChange={handlePageChange}
                          handleSearchFilter={handleSearchFilter}
                          customFilterSection={customeFilterSection}
                          sortOptions={sortingOptions}
                          handleSortColumn={handleSortColumn}
                          handleClearSearch={handleClearSearch}
                          className="custom-header-css"
                          isTab={customActiveTab === "4" ? true : false}
                        />
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="5">
                    <Row>
                      <Col xs="12">
                        <TableContainerV1
                          columns={rejectColumns}
                          data={rejectOrderList}
                          searchHelperText="Search by Request Order ID"
                          pagination={rejectedPagination}
                          handlePageChange={handlePageChange}
                          handleSearchFilter={handleSearchFilter}
                          customFilterSection={customeFilterSection}
                          sortOptions={sortingOptions}
                          handleSortColumn={handleSortColumn}
                          handleClearSearch={handleClearSearch}
                          className="custom-header-css"
                          isTab={customActiveTab === "5" ? true : false}
                        />
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="6">
                    <Row>
                      <Col xs="12">
                        <TableContainerV1
                          columns={rejectColumns}
                          data={cancelledOrderList}
                          searchHelperText="Search by Request Order ID"
                          pagination={cancelledPagination}
                          handlePageChange={handlePageChange}
                          handleSearchFilter={handleSearchFilter}
                          customFilterSection={customeFilterSection}
                          sortOptions={sortingOptions}
                          handleSortColumn={handleSortColumn}
                          handleClearSearch={handleClearSearch}
                          className="custom-header-css"
                          isTab={customActiveTab === "6" ? true : false}
                        />
                      </Col>
                    </Row>
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </div>
      </div>
      <ToastDialog
        message={toastInfo.message}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      />
      <RejectModal
        isCancel={true}
        show={cancelModal}
        onRejectClick={remarks => {
          handleCancelOrder(remarks)
        }}
        onCloseClick={() => setCancelModal(false)}
      />
    </React.Fragment>
  )
}
DealerOrderRequest.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default DealerOrderRequest
